document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('a[href^="#"]').forEach(a=>{
    a.addEventListener('click',e=>{
      const target=a.getAttribute('href');
      const el=document.querySelector(target);
      if(el){e.preventDefault();el.scrollIntoView({behavior:'smooth',block:'start'});}
    });
  });

  document.querySelectorAll('[data-open-modal]').forEach(btn=>{
    btn.addEventListener('click',e=>{
      e.preventDefault();
      const modal=document.querySelector('.store-modal[data-modal="'+btn.dataset.openModal+'"]');
      if(modal){modal.classList.add('is-open');modal.setAttribute('aria-hidden','false');document.body.classList.add('modal-open');}
    });
  });
  document.querySelectorAll('.store-modal-close').forEach(btn=>btn.addEventListener('click',()=>closeModal(btn.closest('.store-modal'))));
  document.querySelectorAll('.store-modal').forEach(modal=>modal.addEventListener('click',e=>{if(e.target===modal)closeModal(modal);}));
  document.addEventListener('keydown',e=>{if(e.key==='Escape') document.querySelectorAll('.store-modal.is-open,.lightbox.is-open').forEach(el=>el.classList.contains('store-modal')?closeModal(el):closeLightbox(el));});
  function closeModal(modal){if(!modal)return;modal.classList.remove('is-open');modal.setAttribute('aria-hidden','true');document.body.classList.remove('modal-open');}

  document.querySelectorAll('[data-gallery]').forEach(gallery=>{
    const root=gallery.closest('#product')||document;
    const slides=[...root.querySelectorAll('.gallery-slide')], thumbs=[...root.querySelectorAll('.gallery-thumb')];
    let current=0;
    const show=i=>{if(!slides.length)return;current=(i+slides.length)%slides.length;slides.forEach((s,n)=>s.classList.toggle('is-active',n===current));thumbs.forEach((t,n)=>t.classList.toggle('is-active',n===current));};
    thumbs.forEach((t,i)=>t.addEventListener('click',()=>show(i)));
    root.querySelectorAll('.zoom-button').forEach((b,i)=>b.addEventListener('click',()=>openLightbox(root,i)));
    show(0);
  });

  function openLightbox(root,index){
    const lb=root.querySelector('.lightbox');
    if(!lb)return;
    const imgs=[...lb.querySelectorAll('.lightbox-image')];
    if(!imgs.length)return;
    let i=Math.max(0,Math.min(index,imgs.length-1));
    const render=()=>imgs.forEach((img,n)=>img.classList.toggle('is-active',n===i));
    const prev=()=>{i=(i-1+imgs.length)%imgs.length;render();};
    const next=()=>{i=(i+1)%imgs.length;render();};
    lb.classList.add('is-open');lb.setAttribute('aria-hidden','false');document.body.classList.add('modal-open');render();
    lb.querySelector('.lightbox-close').onclick=()=>closeLightbox(lb);
    lb.querySelector('.lightbox-prev').onclick=prev;
    lb.querySelector('.lightbox-next').onclick=next;
    lb.onkeydown=e=>{if(e.key==='ArrowLeft')prev();if(e.key==='ArrowRight')next();};
    lb.tabIndex=0;lb.focus();
  }
  function closeLightbox(lb){lb.classList.remove('is-open');lb.setAttribute('aria-hidden','true');document.body.classList.remove('modal-open');}
});

document.addEventListener('DOMContentLoaded',()=>{document.querySelectorAll('[data-review-carousel]').forEach(carousel=>{const section=carousel.closest('.reviews-section');const prev=section?.querySelector('[data-review-prev]');const next=section?.querySelector('[data-review-next]');const step=()=>Math.min(380,carousel.clientWidth*.85);prev?.addEventListener('click',()=>carousel.scrollBy({left:-step(),behavior:'smooth'}));next?.addEventListener('click',()=>carousel.scrollBy({left:step(),behavior:'smooth'}));});});
